import apiClient, { unwrapData } from "./apiClient";

export async function syncRecordings(payload = {}, options = {}) {
  const response = await apiClient.post("/api/recordings/sync", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function getRecordings(params = {}, options = {}) {
  const response = await apiClient.get("/api/recordings", {
    ...options,
    query: {
      phone: params.phone,
      from: params.from,
      to: params.to,
      status: params.status,
      callLogId: params.callLogId,
      page: params.page,
      limit: params.limit,
    },
  });
  const data = unwrapData(response) || {};

  return {
    items: Array.isArray(data.items) ? data.items : [],
    meta: response?.meta || {},
  };
}

export async function getRecording(recordingId, options = {}) {
  const response = await apiClient.get(`/api/recordings/${encodeURIComponent(recordingId)}`, options);
  return unwrapData(response);
}

export async function getRecordingPlayback(recordingId, options = {}) {
  const response = await apiClient.get(
    `/api/recordings/${encodeURIComponent(recordingId)}/play`,
    options,
  );
  return unwrapData(response);
}

export async function getCallLogRecordings(callLogId, options = {}) {
  const response = await apiClient.get(
    `/api/call-logs/${encodeURIComponent(callLogId)}/recordings`,
    options,
  );
  const data = unwrapData(response) || {};

  return Array.isArray(data.items) ? data.items : [];
}
